import React, { useState } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client'
import { IntlProvider } from 'react-intl'

import AssociationsOverviewData from './views/pages/AssociationsOverview/AssociationsOverview.data'

import { registerToGetMessages } from '@/utilities/MessagesManager'
import { addMessages } from '@/utilities/MessagesManager'

import deMessages from './messages/de'
import frMessages from './messages/fr'
import itMessages from './messages/it'

// eslint-disable-next-line no-unused-vars
import log from 'Log'
import { getClient } from '@/react-apollo'

let init = true

addMessages('de', deMessages)
addMessages('fr', frMessages)
addMessages('it', itMessages)

if (!Date.now) {
  Date.now = function now() {
    return new Date().getTime()
  }
}

function InnerApp({lang}: {lang: string}) {
  const
    [language, setLanguage] = useState(lang),
    [deMessages, setDeMessages] = useState({}),
    [frMessages, setFrMessages] = useState({}),
    [itMessages, setItMessages] = useState({})
  const client = getClient()


  if (init) {
    registerToGetMessages('de', (messages: string[]) => {
      if (messages !== deMessages) {
        setDeMessages(messages)
      }
    })
    registerToGetMessages('fr', (messages: string[]) => {
      if (messages !== frMessages) {
        setFrMessages(messages)
      }
    })
    registerToGetMessages('it', (messages: string[]) => {
      if (messages !== itMessages) {
        setItMessages(messages)
      }
    })
    init = false
  }

  if (language !== lang) {
    setLanguage(lang)
  }

  moment.locale(language === 'de' ? 'de-ch' : 'fr-ch')

  return (
    <IntlProvider
      locale={language}
      key={language}
      messages={
        language === 'de' ? deMessages :
        language === 'fr' ? frMessages :
        language === 'it' ? itMessages :
        {}
      }
    >
      <div>
        <ApolloProvider client={client}>
          <AssociationsOverviewData />
        </ApolloProvider>
      </div>
    </IntlProvider>
  )
}

export default function(querySelector: string, language: string) {
  const domNode = document.querySelector(querySelector);
  if (domNode) {
    const root = createRoot(domNode);
    root.render(<InnerApp lang={language||'de'}/>);
    log('Die App läuft, jap', true)
  }
}
